import React from 'react';
/** Services Import */
import Commons from '../../Services/Common/Common';
/** Components Import */
import {
  Box,
  Button,
  Stack,
  Typography,
  TextField,
  Unstable_Grid2 as Grid,
  IconButton,
} from '@mui/material';
import { Combo, Checkbox } from '../../Components/MUIs';
/** Icons Import */
import {
  AccountCircle,
  Visibility,
  VisibilityOff,
  ChevronRight,
} from '@mui/icons-material';
/** Images Import */
import LoginImg from '../../Assets/Images/LoginImg.svg';
import LogoImg from '../../Assets/Images/LogoWidth.svg';
import LoginCover from '../../Assets/Images/login_cover.jpg';
import Icon from '../../Assets/Icon/CustomIcons';
import Lottie from 'lottie-react';
import Animation from '../../Assets/Animations/LoadingLogin.json';
import { AnimatePresence, motion } from 'framer-motion';

function Login(props) {
  const ChangeId = (e) => {
    props.setInputs({
      ...props.inputs,
      userId: e.target.value,
    });
  };

  const ChangePw = (e) => {
    props.setInputs({
      ...props.inputs,
      userPw: e.target.value,
    });
  };

  // User ID Click Event Func
  const SelectedIds = () => {
    const inputIds = document.getElementById('LoginId');
    inputIds.select();
    inputIds.focus();
  };

  // User Password Click Event Func
  const SelectedPws = () => {
    const inputPws = document.getElementById('LoginPw');
    inputPws.select();
    inputPws.focus();
  };

  // pwVisible Value Change Func
  const ChangePasswordVisible = () => {
    props.setInputs({
      ...props.inputs,
      passwordVisible: !props.inputs.passwordVisible,
    });
  };

  return (
    <>
      <Box
        component="main"
        style={{ height: '100vh' }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        <AnimatePresence mode="wait">
          {props.successLogin ? (
            <motion.div
              key="login-success"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6 }}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Lottie animationData={Animation} loop autoplay />
            </motion.div>
          ) : (
            <motion.div
              key="login-form"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ exit: { duration: 0.3 } }}
              style={{ height: '630px', width: '1065px' }}
              // style={{ height: '700px', width: '1200px' }}
            >
              <Box
                sx={{
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#78CB70',
                  borderRadius: '1.5rem',
                }}
              >
                {/* 왼쪽 */}
                <Box
                  sx={{
                    width: '425px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '4rem',
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#FFF',
                        fontSize: '1.4rem',
                        fontWeight: '500',
                        px: '3rem',
                        pb: '3.5rem',
                      }}
                    >
                      환영합니다. <br />
                      산업안전관리 관리자 웹에 <br />
                      로그인해주세요.
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '60%',
                    }}
                  >
                    <img
                      style={{ width: '100%' }}
                      src={LoginImg}
                      alt="로그인 이미지"
                    />
                  </Box>
                </Box>
                {/* 오른쪽 */}
                <Box
                  sx={{
                    height: '100%',
                    width: '640px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#FFF',
                    borderRadius: '1.5rem',
                    gap: '2.5rem',
                    boxShadow:
                      '0px 4px 16px rgba(17,17,26,0.1), 0px 8px 24px rgba(17,17,26,0.1), 0px 16px 56px rgba(17,17,26,0.1)',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '40%',
                    }}
                  >
                    <img
                      style={{ width: '100%' }}
                      src={LogoImg}
                      alt="로고 이미지"
                    />
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      width: '50%',
                      gap: '0.8rem',
                    }}
                  >
                    {/* 아이디 */}
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        backgroundColor: '#F9F9F9',
                        gap: '0.3rem',
                        borderRadius: '3rem',
                        border: props.confirmId ? '' : '1px solid #FF0000',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          width: '100%',
                          gap: '0.3rem',
                          py: '0.5rem',
                          px: '1rem',
                        }}
                      >
                        <Icon.User
                          width={'25px'}
                          color={props.confirmId ? '' : '#FF0000'}
                        />
                        <input
                          id="LoginId"
                          placeholder="아이디를 입력해주세요."
                          label={
                            props.lanList.length > 0
                              ? props.lanList.filter((f) => f.lanId === 'Id')[0]
                                  .lanNm
                              : ''
                          } // ID
                          name={
                            props.lanList.length > 0
                              ? props.lanList.filter((f) => f.lanId === 'Id')[0]
                                  .lanNm
                              : ''
                          } // ID
                          style={{
                            width: '100%',
                            border: 'none',
                            outline: 'none',
                            backgroundColor: 'transparent',
                            fontSize: '0.8rem',
                          }}
                          onFocus={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                          }}
                          value={props.inputs.userId}
                          onChange={ChangeId}
                          onClick={SelectedIds}
                        />
                      </Box>
                    </Box>
                    {/* 비밀번호 */}
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        backgroundColor: '#F9F9F9',
                        gap: '0.3rem',
                        borderRadius: '3rem',
                        border: props.confirmPw ? '' : '1px solid #FF0000',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          width: '100%',
                          gap: '0.3rem',
                          py: '0.5rem',
                          px: '1rem',
                        }}
                      >
                        <Icon.PassWord
                          width={'28px'}
                          color={props.confirmPw ? '' : '#FF0000'}
                        />
                        <input
                          id="LoginPw"
                          placeholder="비밀번호를 입력해주세요."
                          label={
                            props.lanList.length > 0
                              ? props.lanList.filter(
                                  (f) => f.lanId === 'Password'
                                )[0].lanNm
                              : ''
                          } // Password
                          name={
                            props.lanList.length > 0
                              ? props.lanList.filter(
                                  (f) => f.lanId === 'Password'
                                )[0].lanNm
                              : ''
                          } // Password
                          value={props.inputs.userPw}
                          onChange={ChangePw}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              props.LoginLogic();
                            }
                          }}
                          type={!props.inputs.passwordVisible ? 'password' : ''}
                          onClick={SelectedPws}
                          style={{
                            width: '100%',
                            border: 'none',
                            outline: 'none',
                            backgroundColor: 'transparent',
                            fontSize: '0.8rem',
                          }}
                        />
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        pl: '1.3rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        fontSize: '0.8rem',
                      }}
                    >
                      <input
                        type="checkbox"
                        style={{ width: '16px', height: '16px' }}
                      />
                      <span>로그인 유지</span>
                    </Box>
                    <Button
                      fullWidth
                      size="large"
                      sx={{
                        backgroundColor: '#1BBD2E',
                        fontSize: '15px !important',
                        boxShadow: '0 3px 10px rgb(0,0,0,0.2) !important',
                      }}
                      variant="contained"
                      onClick={() => {
                        props.LoginLogic();
                      }}
                    >
                      로그인
                    </Button>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        px: 0.25,
                        pt: 0.5,
                      }}
                    >
                      <Typography
                        component="button"
                        type="button"
                        onClick={() => props.DialogLogic?.('FindPw')}
                        sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          cursor: 'pointer',
                          color: '#6B7280',
                          fontSize: '0.875rem',
                          fontWeight: 500,
                          border: 'none',
                          background: 'none',
                          p: 0,
                          '&:hover': { color: '#2EBD36' },
                          '&:hover .findpw-chevron': {
                            transform: 'translateX(2px)',
                          },
                        }}
                      >
                        비밀번호를 잊어버리셨나요?
                        <ChevronRight
                          className="findpw-chevron"
                          sx={{
                            fontSize: 18,
                            ml: 0.25,
                            transition: 'transform 0.2s',
                          }}
                        />
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </motion.div>
          )}
        </AnimatePresence>
      </Box>
    </>
  );
}

export default Login;
